import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { providersService } from '../../services';

// Async thunks
export const fetchModelOptions = createAsyncThunk(
  'modelOptions/fetchModelOptions',
  async (_, { rejectWithValue }) => {
    try {
      const data = await providersService.list();
      return data.providers || data.data || data || [];
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  modelOptions: [],
  loading: false,
  error: null,
};

const modelOptionsSlice = createSlice({
  name: 'modelOptions',
  initialState,
  reducers: {
    clearError: state => {
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchModelOptions.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchModelOptions.fulfilled, (state, action) => {
        state.loading = false;
        state.modelOptions = action.payload;
      })
      .addCase(fetchModelOptions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = modelOptionsSlice.actions;

// Selectors
export const selectModelOptions = state => state.modelOptions.modelOptions;
export const selectModelOptionsLoading = state => state.modelOptions.loading;
export const selectModelOptionsError = state => state.modelOptions.error;

// Helper selectors
export const selectAIModels = state =>
  state.modelOptions.modelOptions.filter(option => option.category === 'ai_models');

export const selectSTTModels = state =>
  state.modelOptions.modelOptions.filter(option => option.category === 'stt_models');

export const selectTTSModels = state =>
  state.modelOptions.modelOptions.filter(option => option.category === 'tts_models');

export const selectModelsForProvider = (category, provider) => state => {
  const categoryOptions = state.modelOptions.modelOptions.filter(
    option => option.category === category
  );
  const providerOption = categoryOptions.find(option => option.provider === provider);
  return providerOption?.models || [];
};

export default modelOptionsSlice.reducer;
